import { IntlShape } from "react-intl";

const getDefaultAllSelectCaption = (allSelected: boolean, isFiltering: boolean, intl: IntlShape) =>
  (allSelected
    ? intl.formatMessage({
        id: "selectEntityDialog.default.deselectAll",
        defaultMessage: "Deselect All",
        description: "Deselect all message for select entity dialog factory",
      })
    : intl.formatMessage({
        id: "selectEntityDialog.default.selectAll",
        defaultMessage: "Select All",
        description: "Select all message for select entity dialog factory",
      })) +
  (isFiltering
    ? intl.formatMessage({
        id: "selectEntityDialog.default.filterTitle",
        defaultMessage: " filtered items",
        description: "Filter title message for select entity dialog factory",
      })
    : "");

export default getDefaultAllSelectCaption;
